import script from "./jianmoDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./jianmoDetails.vue?vue&type=script&setup=true&lang=ts"

import "./jianmoDetails.vue?vue&type=style&index=0&id=52af0e4c&lang=scss&scoped=true"

import exportComponent from "E:\\svn\\xmTask(国振资产管理)1\\views\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52af0e4c"]])

export default __exports__